
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      id="home" 
      className="min-h-screen flex items-center relative bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/a3a1cbc6e42ff3a4513660dc2d4f20f7.jpg')`
      }}
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Your Trusted partner for international trade
          </h1>
          <p className="text-2xl md:text-3xl text-gray-200 mb-8 font-light">
            Global sources. Dubai Standards.
          </p>
          
          {/* About Us Section */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">About Us</h2>
            <p className="text-lg text-gray-200 italic leading-relaxed">
              At PGVHarmony F.Z.E we specialize in global import and export solutions that connect businesses across borders. With a strong network of trusted partners, we ensure seamless trade operations, reliable logistics, and high-quality products.
              Our mission is to make international trade efficient, transparent, and sustainable — helping our clients expand their reach and grow their businesses worldwide.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <button 
              onClick={() => {
                const element = document.getElementById('products');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors flex items-center justify-center cursor-pointer whitespace-nowrap"
            >
              <i className="ri-eye-line mr-2"></i>
              View Products
            </button>
            <button 
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-colors flex items-center justify-center cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Get Quote
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-global-line text-blue-600 text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Global Reach</h3>
              <p className="text-gray-200 text-sm">Worldwide shipping and distribution network</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-shield-check-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Quality Assured</h3>
              <p className="text-gray-200 text-sm">Certified products meeting international standards</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-customer-service-2-line text-purple-600 text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Expert Support</h3>
              <p className="text-gray-200 text-sm">Dedicated team for all your trading needs</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
